import { useEffect, useState } from 'react';
import { axiosInstance } from 'utils/axios';

// material-ui
import { Box, Button, Grid, Typography, TextField, Select, MenuItem, Autocomplete, CircularProgress, Checkbox } from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';
import { gridSpacing } from 'app/constant';
import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import StickyHeadTable from './components/StickyHeadTable';
import { warningAlert, successAlert, errorAlert } from 'ui-component/Toasts';
import useFetchData from 'hooks/useFetchData';
import InsertAddressRecord from './components/InsertAddressRecords';

const Addresses = () => {
    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();

    console.log(token);

    const [addresses, setaddresses] = useState([]);
    const [fromAddressName, setfromAddressName] = useState('');
    const [toAddressName, settoAddressName] = useState('');
    const [filterActive, setFilterActive] = useState(true);
    const [isLoading, setLoading] = useState(false);
    const [fromCityName, setfromCityName] = useState('');
    const [toCityName, settoCityName] = useState('');
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const fetchaddressesRecord = async () => {
        let addressesRecordURL = `/Addresses/All?`;
        if (fromAddressName !== '') {
            addressesRecordURL += `&fromAddressName=${fromAddressName}`;
        }

        if (toAddressName !== '') {
            addressesRecordURL += `&toAddressName=${toAddressName}`;
        }

        if (fromCityName !== '') {
            addressesRecordURL += `&fromCityName=${fromCityName}`;
        }

        if (fromCityName !== '') {
            addressesRecordURL += `&toCityName=${toCityName}`;
        }

        if (filterActive !== 0) {
            addressesRecordURL += `&active=${filterActive}`;
        }
        setLoading(true);
        setFilterBtnDisabled(true);
        try {
            const res = await axiosInstance.get(addressesRecordURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setaddresses(res.data);
                console.log(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
            setFilterBtnDisabled(false);
        }
    };

    const { data: CityNames } = useFetchData('/Cities/All');

    return (
        <Grid container item xs={12} padding="20px">
            <InsertAddressRecord cityNames={CityNames} />
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            From Address Name :
                        </Typography>
                        <input
                            type="text"
                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                            value={fromAddressName}
                            onChange={(e) => setfromAddressName(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            To Address Name :
                        </Typography>
                        <input
                            type="text"
                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                            value={toAddressName}
                            onChange={(e) => settoAddressName(e.target.value)}
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            From City Name :
                        </Typography>

                        <Autocomplete
                            freeSolo
                            value={fromCityName}
                            onChange={(event, newValue) => {
                                setfromCityName(newValue);
                            }}
                            inputValue={fromCityName}
                            onInputChange={(event, newInputValue) => {
                                setfromCityName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={CityNames.map((city) => ({ label: city.name, value: city.id }))}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            To City Name :
                        </Typography>

                        <Autocomplete
                            freeSolo
                            value={toCityName}
                            onChange={(event, newValue) => {
                                settoCityName(newValue);
                            }}
                            inputValue={toCityName}
                            onInputChange={(event, newInputValue) => {
                                settoCityName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={CityNames.map((city) => ({ label: city.name, value: city.id }))}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Active :
                        </Typography>
                        <Checkbox
                            checked={filterActive}
                            onChange={(e) => setFilterActive(e.target.checked)} // Use checked value directly
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={12} lg={12}>
                    <Button
                        variant="contained"
                        sx={{
                            float: 'right',
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '30px'
                        }}
                        onClick={() => fetchaddressesRecord()}
                        disabled={filterBtnDisabled}
                    >
                        Filter
                    </Button>
                </Grid>
                <Box sx={{ width: '100%', minHeight: '200px' }}>
                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <StickyHeadTable addresses={addresses} fetchaddressesRecord={fetchaddressesRecord} cityNames={CityNames} />
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default Addresses;
